import React, { useEffect, useState } from "react";
import { useSelector } from "react-redux";

import { getCopyBlock } from "api/requests/directus/getCopyBlock";
import { CopyBlocks } from "custom-types/Directus";
import { getDomainCountryCode } from "redux/selectors/config";

import Divider from "components/StrainPage/Divider";

import CopyBlock from "./CopyBlock";

type Props = {
  collection: string;
  slug: string;
  className?: string;
};

const CopyBlockWithData = ({ collection, slug, className }: Props) => {
  const [copyBlocks, setCopyBlocks] = useState<CopyBlocks>();
  const countryCode = useSelector(getDomainCountryCode);

  useEffect(() => {
    getCopyBlock(collection, slug, countryCode).then((data) => {
      if (data) {
        setCopyBlocks(data);
      }
    });
  }, []);

  return copyBlocks && copyBlocks.copy_block.length > 0 ? (
    <div className="copy-block-section">
      <Divider />
      <div className="copy-block-container px-lg">
        <CopyBlock data={copyBlocks} className={className} />
      </div>
    </div>
  ) : (
    <></>
  );
};

export default CopyBlockWithData;
